<template>
  <div class="demo-container">
    <div class="left-container">
      <div class="sidebar-title">
        {{ categoryName }}
      </div>
      <div class="sidebar-content">
        <demo-sidebar
          :sidebar-data="menuData"
          :check-key="checkKey"
        />
      </div>
    </div>
    <code-editor :code="code" />
  </div>
</template>

<script>
import demoSidebar from '~/components/demo-sidebar-menu';
import codeEditor from '~/components/code-editor';
import { getSidebarDataApi, getCategoryInfoApi, getDemoIdApi, getCodeApi } from '~/service/web-service';
import util from '~/utils/index';
import { errorLogger } from '~/utils/logger';

export default {
  layout: 'demo',
  middleware: 'handleHost',
  components: {
    demoSidebar,
    codeEditor
  },
  async asyncData({ params, error, navInit, script }) {
    try {
      const pathArr = params.pathMatch.split('/').filter(path => !!path);
      if (!pathArr.length) {
        error({
          statusCode: 404,
          message: '404 Not Found'
        });
        return;
      }
      const categoryPathName = `/${pathArr[0]}`;
      const currentPathName = `/${pathArr.join('/')}`;
      const [sidebarData, categoryInfo, currentCategoryInfo] = await Promise.all([
        getSidebarData(categoryPathName),
        getCategoryInfo(categoryPathName),
        getCategoryInfo(currentPathName),
      ]);
      return {
        categoryPathName,
        sidebarData,
        categoryName: categoryInfo.name || '',
        currentCategoryInfo,
        navInit,
        script,
      };
    } catch (err) {
      console.error(err);
      errorLogger(err);
    }
  },
  data() {
    return {
      categoryPathName: '',
      sidebarData: [],
      menuData: [],
      categoryName: '',
      currentCategoryInfo: [],
      code: '',
      checkKey: '',
      currentId: '',
    };
  },
  created() {
    this.currentId = this.currentCategoryInfo.category_id;
    if (!(Array.isArray(this.menuData) && this.menuData.length > 0)) {
      this.menuData = this.handleSiderBarData(`/webDemoCenter${this.categoryPathName}`, '', this.sidebarData);
      console.log('this.menuData: ', this.menuData);
    }
    this.checkKey = String(this.currentId);
  },
  async mounted() {
    try {
      util.initPageComponents(this.navInit);
      const articleId = await getDemoId(this.currentId);
      this.code = await getCode(this.currentId, articleId);
      console.log('this.checkKey: ', this.checkKey);
    } catch (err) {
      console.error(err);
    }
  },
  methods: {
    handleSiderBarData(path, pathId, sidebarData) {
      return sidebarData
        .filter(item => {
          const { type, sub_categorys } = item;
          switch (type) {
            case 1:
              return Array.isArray(sub_categorys) && sub_categorys.length > 0;
            case 2:
              return true;
            default:
              return false;
          }
        })
        .map(item => {
          const itemPath = `${path}/${item.path_name}`;
          const itemPathId = `${pathId}/${item.category_id}`;
          return {
            index: String(item.category_id),
            name: item.name,
            type: item.type,
            path: itemPath,
            pathId: itemPathId,
            children: this.handleSiderBarData(itemPath, itemPathId, item.sub_categorys),
          };
        });
    },
  },
  head() {
    return {
      title: `${this.currentCategoryInfo.name} | 腾讯位置服务`,
      meta: [
        { hid: 'description', name: 'description', content: '腾讯地图开放平台为各类应用厂商和开发者提供基于腾讯地图的地理位置服务和解决方案；有针对Web应用的JavaScript API, 适合手机端Native APP的各种SDK, WebService接口和各类地图API等。' },
        { hid: 'keywords', name: 'keywords', content: '腾讯地图开放平台，腾讯地图api，qq地图，腾讯地图街景api，地图api，手机定位api，腾讯lbs，qq map api，qq地图api' }
      ],
      script: this.script
    };
  },
};

async function getSidebarData(pathName) {
  try {
    const data = await getSidebarDataApi({
      path_name: pathName,
      level: 10
    });
    return data.categorys;
  } catch (err) {
    console.error(err);
  }
}

async function getCategoryInfo(pathName, categoryId) {
  try {
    const res = await getCategoryInfoApi({
      path_name: pathName
    });
    if (!categoryId) {
      return res[0] || {};
    }
    return (res.filter(item => item.category_id === categoryId))[0] || {};
  } catch (err) {
    console.error(err);
  }
}

async function getDemoId(currentId) {
  try {
    const res = await getDemoIdApi({
      parent_id: currentId
    });
    return res.length > 0 ? res[0].id : 0;
  } catch (err) {
    console.error(err);
  }
}

async function getCode(parentId, articleId) {
  try {
    const res = await getCodeApi({
      parent_id: parentId,
      article_id: articleId
    });
    return res[0] ? res[0].content : '';
  } catch (err) {
    console.error(err);
  }
}

</script>
<style lang="scss">
.demo-container {
  position: absolute;
  left: 0;
  top: 72px;
  bottom: 0;
  width: 100%;
  padding-bottom: 0;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  overflow: hidden;
  .left-container {
    width: 245px;
    height: 100%;
    top: 0;
    left: 0;
    position: absolute;
    border-right: 1px solid #eee;
    background: #fff;
    .sidebar-title {
      font-size: 16px;
      font-weight: 600;
      color: #10131F;
      line-height: 28px;
      padding: 14px 30px;
      border-bottom: 1px solid #E6EAF4;
    }
    .sidebar-content {
      position: absolute;
      top: 57px;
      left: 0;
      right: 0;
      bottom: 0;
      overflow-y: auto;
    }
  }
}
</style>
